import { createClient } from '@supabase/supabase-js'

//const supabaseUrl = 'https://mmjxtfshoomezbbytwup.supabase.co'
//const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1tanh0ZnNob29tZXpiYnl0d3VwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU4ODQwMTQsImV4cCI6MjA1MTQ2MDAxNH0.unIKTCoBmiIADUbNmSoH08Z4ltR85DpdJc8QX6_rezk'
const supabaseUrl = 'https://kucphzyqwgzcvjmyzfcs.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt1Y3Boenlxd2d6Y3ZqbXl6ZmNzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYwNTE1MDgsImV4cCI6MjA1MTYyNzUwOH0.WM95mLDbsvdj4hKjV-RVR5b8nankT0iDlb4qc0YUegU'
export const supabase = createClient(supabaseUrl, supabaseKey)
